function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1-Copy",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "v2---saved-searches-menu",
  transform: "translate(-967.000000, -120.000000)",
  fill: "#BFBFBF"
}, /*#__PURE__*/React.createElement("g", {
  id: "user-menu",
  transform: "translate(955.000000, 59.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("g", {
  id: "menu-saved-searches"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(6.000000, 18.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icons/star/on",
  transform: "translate(0.000000, 38.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.3211151,5 L7.47444502,5 C6.66012132,5 6,5.65864784 6,6.47115385 L6,20.6923077 L11.8977801,17.2596154 L17.7955601,20.6923077 L17.7955601,6.47115385 C17.7955601,5.65864784 17.1354388,5 16.3211151,5 Z M16.3211151,18.1309675 L11.8977801,15.5564483 L7.47444502,18.1309675 L7.47444502,6.65504808 C7.47444502,6.5534861 7.55696146,6.47115385 7.65875065,6.47115385 L16.1368095,6.47115385 C16.2386076,6.47115385 16.3211151,6.55338522 16.3211151,6.65492548 L16.3211151,18.1309675 Z",
  id: "Shape"
})))))))));

var SvgStar = function SvgStar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "16px",
    viewBox: "0 0 12 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/star.d26641a5.svg";
export { ForwardRef as ReactComponent };